import React from "react";
import ApproveIcon from "../../../asset/approve-icon.png";
import CancelIcon from "../../../asset/cancel-icon.png";
import { kepalaShiftTimOne, kepalaShiftTimTwo } from "../../../constant";
import "./FormLembur.css";
import { useFormLembur } from "./useFormLembur";
import Select from "react-select";
import { clockJam } from "../../../constant";
import RefreshIcon from "../../../asset/refresh-icon.png";
import WaitingIcon from "../../../asset/waiting_icon.png";
import ApprovedIcon from "../../../asset/approved_icon.png";
import DeleteIcon from "../../../asset/delete_icon.png";
import { hasRole } from "../../../util/function";
import moment from "moment";

// samakan tampilan react-select dengan input lain
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 36,
    borderRadius: 8,
    borderColor: state.isFocused ? "dodgerblue" : "#e4e7eb",
    boxShadow: "none",
    fontSize: 14,
    "&:hover": { borderColor: state.isFocused ? "dodgerblue" : "#cbd2d9" },
  }),
  menu: (base) => ({ ...base, zIndex: 20 }),
};

const formatPlan = (value) => moment(value, "h:mm:ss A").format("HH:mm");
const formatActual = (value) => (value ? moment(value).format("HH:mm") : "");

const Field = ({ label, required, className = "", children }) => (
  <div className={`lembur-field ${className}`}>
    <label className="lembur-label">
      {label}
      {required && <span className="lembur-required">*</span>}
    </label>
    {children}
  </div>
);

const FormLembur = () => {
  const {
    dataUser,
    listLembur,
    filterCatatan,
    dateFilter,
    setDateFilter,
    filterKepala,
    setFilterKepala,
    reFormat,
    operatorPick,
    setOperatorPick,
    rencanaMasuk,
    setRencanaMasuk,
    rencanaKeluar,
    setRencanaKeluar,
    pekerjaan,
    setPekerjaan,
    catatan,
    setCatatan,
    handleKirimLembur,
    setIsReload,
    filterKepalaList,
    setFilterKepalaList,
    filterApproval,
    handleApproval,
    handleDelete,
  } = useFormLembur();

  const kepalaOptions =
    dataUser.tim === 1 ? kepalaShiftTimOne : kepalaShiftTimTwo;

  const isApproved = !filterApproval && listLembur && listLembur.length > 0;

  return (
    <div className="container-formlembur">
      <div className="wrapper-card-formlembur">
        <h2 className="lembur-title">Form Lembur</h2>

        {/* ===== Form input (khusus super_user / hrd_admin) ===== */}
        {hasRole(dataUser, "super_user", "hrd_admin") && (
          <div className="lembur-form">
            <Field label="Tanggal Lembur">
              <input
                type="date"
                className="lembur-input"
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
              />
            </Field>

            <Field label="Kepala" required>
              <select
                className="lembur-input"
                value={filterKepala || "Pilih Kepala"}
                onChange={(e) => setFilterKepala(e.target.value)}
              >
                <option disabled value="Pilih Kepala">
                  Pilih Kepala
                </option>
                {kepalaOptions.map((obj) => (
                  <option key={obj.value} value={obj.value}>
                    {obj.name}
                  </option>
                ))}
              </select>
            </Field>

            <Field label="Operator" required className="lembur-field-wide">
              <Select
                placeholder="Pilih Operator"
                options={reFormat}
                value={operatorPick || ""}
                onChange={setOperatorPick}
                styles={selectStyles}
              />
            </Field>

            <Field label="Rencana Masuk" required>
              <div className="lembur-time">
                <Select
                  placeholder="Jam"
                  options={clockJam}
                  value={rencanaMasuk || ""}
                  onChange={setRencanaMasuk}
                  styles={selectStyles}
                />
                <span>: 00</span>
              </div>
            </Field>

            <Field label="Rencana Keluar" required>
              <div className="lembur-time">
                <Select
                  placeholder="Jam"
                  options={clockJam}
                  value={rencanaKeluar || ""}
                  onChange={setRencanaKeluar}
                  styles={selectStyles}
                />
                <span>: 00</span>
              </div>
            </Field>

            <Field label="Pekerjaan">
              <input
                type="text"
                className="lembur-input"
                placeholder="Pekerjaan"
                value={pekerjaan}
                onChange={(e) => setPekerjaan(e.target.value)}
              />
            </Field>

            <Field label="Catatan">
              <input
                type="text"
                className="lembur-input"
                placeholder="Catatan"
                value={catatan}
                onChange={(e) => setCatatan(e.target.value)}
              />
            </Field>

            <div className="lembur-submit">
              <button
                className="lembur-btn lembur-btn-primary"
                onClick={() => handleKirimLembur()}
              >
                Tambah
              </button>
            </div>
          </div>
        )}

        {/* ===== Daftar lembur ===== */}
        <div className="lembur-list-head">
          <div>
            <h3 className="lembur-subtitle">Daftar Lembur</h3>
            <span className="lembur-doccode">Form-HRD-A16-R0</span>
          </div>
          <span
            className={`lembur-status ${
              isApproved ? "is-approved" : "is-waiting"
            }`}
          >
            <img src={isApproved ? ApprovedIcon : WaitingIcon} alt="" />
            {isApproved ? "Disetujui" : "Menunggu approval"}
          </span>
        </div>

        <div className="lembur-toolbar">
          <input
            type="date"
            className="lembur-input"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />
          <select
            className="lembur-input"
            value={filterKepalaList || "Pilih Kepala"}
            onChange={(e) => setFilterKepalaList(e.target.value)}
          >
            <option disabled value="Pilih Kepala">
              Pilih Kepala
            </option>
            {kepalaOptions.map((obj) => (
              <option key={obj.value} value={obj.value}>
                {obj.name}
              </option>
            ))}
          </select>
          <button
            className="lembur-icon-btn"
            title="Muat ulang"
            aria-label="Muat ulang"
            onClick={() => setIsReload(true)}
          >
            <img src={RefreshIcon} alt="" />
          </button>
        </div>

        <div className="lembur-table-scroll">
          <table className="lembur-table">
            <thead>
              <tr>
                <th className="col-no">No</th>
                <th className="col-name">Nama</th>
                <th>Rencana Masuk</th>
                <th>Aktual Masuk</th>
                <th>Rencana Keluar</th>
                <th>Aktual Keluar</th>
                <th className="col-job">Pekerjaan</th>
                <th className="col-icon" />
                <th className="col-icon" />
              </tr>
            </thead>
            <tbody>
              {listLembur &&
                listLembur.map((e, index) => (
                  <tr key={e.uuid ?? index}>
                    <td className="col-no">{index + 1}.</td>
                    <td className="col-name">{e.name}</td>
                    <td className="col-time">
                      {formatPlan(e && e.rencanaMasuk)}
                    </td>
                    <td className="col-time">{formatActual(e.aktualMasuk)}</td>
                    <td className="col-time">
                      {formatPlan(e && e.rencanaKeluar)}
                    </td>
                    <td className="col-time">{formatActual(e.aktualKeluar)}</td>
                    <td className="col-job">{e.pekerjaan}</td>
                    <td className="col-icon">
                      <img
                        src={e.aktualKeluar ? ApproveIcon : CancelIcon}
                        alt={e.aktualKeluar ? "Selesai" : "Belum selesai"}
                      />
                    </td>
                    <td className="col-icon">
                      <button
                        className="lembur-icon-btn lembur-icon-btn-sm"
                        title="Hapus"
                        aria-label={`Hapus ${e.name}`}
                        onClick={() => handleDelete(e.uuid)}
                      >
                        <img src={DeleteIcon} alt="" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {(!listLembur || listLembur.length === 0) && (
            <div className="lembur-empty">Belum ada data lembur.</div>
          )}
        </div>

        <div className="lembur-note">
          <b>Catatan</b>
          <p>{filterCatatan[0] || "-"}</p>
        </div>

        {filterApproval && (
          <div className="lembur-approve">
            <button
              className="lembur-btn lembur-btn-success"
              onClick={() => handleApproval()}
            >
              Approve
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormLembur;
